import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PaymentHeader from '../../components/student/payment/PaymentHeader';
import SubmissionsTable from '../../components/student/payment/SubmissionsTable';
import BankDepositInfo from '../../components/student/payment/BankDepositInfo';
import PaymentUploadModal from '../../components/student/payment/PaymentUploadModal';
import { fetchAPI } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

const BANK_DETAILS = [
    {
        bank: 'Bank of Ceylon',
        logo: 'https://upload.wikimedia.org/wikipedia/en/1/1e/Bank_of_Ceylon.svg',
        accountName: 'Sudesh Rathnayaka',
        accountNo: '83990263',
        branch: 'Kiridiwela Branch'
    }
];

export default function StudentPayment() {
    const { currentUser } = useAuth();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [classes, setClasses] = useState([]);

    const [formData, setFormData] = useState({
        classId: location.state?.classId || '',
        month: location.state?.monthName || '',
        referenceNo: '',
        slip: null,
        amount: ''
    });

    React.useEffect(() => {
        if (location.state?.classId) {
            setIsModalOpen(true);
        }
    }, [location.state]);

    React.useEffect(() => {
        const loadPaymentData = async () => {
            if (!currentUser) return;
            try {
                // 1. Load submissions
                const subData = await fetchAPI(`/payment/get_submissions.php?user_id=${currentUser.id}`);
                setSubmissions(subData);

                // 2. Load teachers to get classes
                const teachersData = await fetchAPI('/student/get_teachers.php');
                const allClasses = [];
                for (const t of teachersData) {
                    const details = await fetchAPI(`/student/get_teacher_details.php?teacher_id=${t.id}`);
                    allClasses.push(...details.classes);
                }
                setClasses(allClasses);
            } catch (err) {
                console.error("Failed to load payment data", err);
            } finally {
                setLoading(false);
            }
        };
        loadPaymentData();
    }, [currentUser]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            data.append('user_id', currentUser.id);
            data.append('class_id', formData.classId);
            data.append('month_name', formData.month);
            data.append('reference_no', formData.referenceNo);
            data.append('amount', formData.amount);
            data.append('slip', formData.slip);

            await fetchAPI('/payment/submit_slip.php', {
                method: 'POST',
                body: data
            });

            // Refresh list
            const subData = await fetchAPI(`/payment/get_submissions.php?user_id=${currentUser.id}`);
            setSubmissions(subData);

            setIsModalOpen(false);
            setFormData({ classId: '', month: '', referenceNo: '', slip: null, amount: '' });
            alert("Payment slip submitted successfully!");
        } catch (err) {
            alert("Failed to submit: " + err.message);
        }
    };

    if (loading) return <div className="p-8 text-center text-gray-500 font-bold">Loading payment info...</div>;

    return (
        <div className="space-y-6 relative">
            <PaymentHeader onOpenModal={() => setIsModalOpen(true)} />
            <SubmissionsTable submissions={submissions} />
            <BankDepositInfo bankDetails={BANK_DETAILS} />
            <PaymentUploadModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleSubmit}
                classes={classes}
            />
        </div>
    );
}
